/**
 * Provides a gui for uploading images in bulk.
 * @module images/upload-bulk
 */
import React from 'react'
import _pick from 'lodash/pick'
import { connect as connectRedux } from 'react-redux'
import { compose } from 'recompose'
import { Paper } from '@mui/material'
import { getFilteredMenuItems } from 'services/menu'
import './index.scss'
import Page from '../page'

/**
 * React component
 */
function HomePage (props) {
  const { config, auth } = props

  return (
    <Page className="home-page">
      <Paper className="home-page__panel" elevation={0}>
        <h2 className="page__title">Services</h2>
        <ul className="services">
          {getFilteredMenuItems({ config, auth }).map((item, index) => (
            <li key={`${index}-${item.label}`} className="service">
              <a href={item.path}>{item.label}</a>
            </li>
          ))}
        </ul>
      </Paper>
    </Page>
  )
}

export default compose(connectRedux((state) => _pick(state, ['config', 'auth'])))(HomePage)
